import script from "./TechnicianTicketDetailView.vue?vue&type=script&setup=true&lang=js"
export * from "./TechnicianTicketDetailView.vue?vue&type=script&setup=true&lang=js"

import "./TechnicianTicketDetailView.vue?vue&type=style&index=0&id=024056f2&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-024056f2"]])

export default __exports__